import { Reveal } from "../lib/reveal";

const chapters = [
  {
    n: "01",
    title: "Specialists, not generalists",
    body: "We come from the built environment. No translation layer, no jargon deck — we understand the work and the way practices win it.",
  },
  {
    n: "02",
    title: "Evidence over opinion",
    body: "Decisions grounded in your numbers, your pipeline and your delivery data — not a recycled playbook from another sector.",
  },
  {
    n: "03",
    title: "Build, don't just advise",
    body: "We stay hands-on until the change sticks. Systems installed, teams trained, results measured.",
  },
  {
    n: "04",
    title: "Small, sharp, senior",
    body: "You work directly with the people doing the thinking. No layers, no hand-offs to juniors.",
  },
];

export const Manifesto = () => (
  <section
    id="manifesto"
    data-testid="manifesto-section"
    className="bg-foreground text-background py-24 md:py-32"
  >
    <div className="px-5 md:px-10 max-w-[1400px] mx-auto">
      <Reveal>
        <p className="font-mono text-xs tracking-[0.25em] uppercase text-primary mb-4">03 / How we think</p>
        <h2 className="font-display font-bold text-4xl md:text-6xl tracking-tight leading-none max-w-3xl">
          A short manifesto.
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 border-t border-white/15">
        {chapters.map((c, i) => (
          <Reveal
            key={c.n}
            delay={i * 0.08}
            className={`border-b border-white/15 md:[&:nth-child(odd)]:border-r border-white/15 p-8 md:p-12`}
          >
            <div data-testid={`manifesto-chapter-${c.n}`} className="flex gap-6">
              <span className="font-mono text-primary text-sm pt-2">{c.n}</span>
              <div>
                <h3 className="font-display font-semibold text-2xl md:text-3xl tracking-tight">{c.title}</h3>
                <p className="text-white/60 mt-3 leading-relaxed">{c.body}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
